import { UsageTab } from '@/features/ai/UsageTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/ai/usage')({
  component: UsageTab,
});
